import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Container, Form, FormGroup, Label, Row, Spinner } from 'reactstrap'
import IconCard from 'pages/Ui/Cards/IconCard'
import { FaMoneyCheckDollar } from "react-icons/fa6";
import AddCreditButton from './AddCreditButton';
import { useNavigate } from 'react-router-dom';
import { useWebSocket } from 'context/WebSocketContext';
import useUpdateWallet from '../users/hooks/useUpdateWallet';
import { useForm } from 'react-hook-form';
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import useGetWalletData from './hooks/useGetWalletData';
import RefreshButton from './components/RefreshButton';

const DisplayCredits = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const handleAddCredits = () =>{navigate('/payments')}

    // logged in user role
    const[loggedRole, setLoggedRole] = useState('');

    // getting data from local storage
    useEffect(()=>{
        const roleData = JSON.parse(localStorage.getItem('userData'))
        if(roleData){
            const role = roleData.user.role;
            setLoggedRole(role);
        }
        
    },[])

    const {isPending,isFetching,refetch,data} = useGetWalletData()
    console.log(`wallet:`,data)
    const walletDataFromAPI = data?.results?.[0]

    const {walletData} = useWebSocket();
    console.log("wallet socket",walletData)

    const [cred,setCred] = useState(null);

    // fresh fetch always updates cred
    useEffect(() => {
      if (walletDataFromAPI) setCred(walletDataFromAPI)
    }, [walletDataFromAPI])

    // real socket push also updates cred (only when it actually changes)
    useEffect(() => {
      if (walletData) setCred(walletData)
    }, [walletData])

    // const cred = walletData ?? walletDataFromAPI

    // custom hook
    const{isUpdating,isUpdated,updateUserWallet} = useUpdateWallet();

    const {register,watch,control,handleSubmit,reset} = useForm({
      defaultValues:{
        "low_bal_alert": false,
        "threshold": 0
      }
    })

    useEffect(()=>{

      if(!walletDataFromAPI) return;

      const resetPaylod = {
        low_bal_alert: walletDataFromAPI.low_bal_alert,
        threshold: Number(walletDataFromAPI.threshold)
      }

      reset(resetPaylod)
    },[walletDataFromAPI,reset])

    const onSubmit = async (data) =>{
      console.log("in onsubmit",data)
      if (!cred) return;

      const payload = {
        id: cred.id,
        low_bal_alert: data.low_bal_alert,
        threshold: Number(data.threshold),
      }

      toast.loading("Updating User Wallet...",{id:"wallet-update"})

      updateUserWallet(payload,{
        onSuccess:(data)=>{
          queryClient.invalidateQueries(["userWallet"])
          queryClient.setQueryData(["userData"],(old)=>{
            if(!old) return old;

            const updatedUser = {
              ...old,
              wallet: data
            }

            localStorage.setItem(
              "userData",
              JSON.stringify(updatedUser)
            );

            return updatedUser
          })
        }
      })
    }
    
  return (
    <div className="py-3">
      <Card className="p-4">
        
        <div className="border-bottom pb-2 mb-4 d-flex">
          <h5 className="fw-bold">Credit Dashboard</h5>
          <div className='ms-3'>
            <RefreshButton onRefresh={refetch} isRefreshing={isFetching}/>
          </div>
          {loggedRole === "00000000-0000-0000-0000-000000000002" &&<div className='ms-auto'>
            <Button color='info' outline onClick={()=>navigate('/transaction-history')}>
              Transaction History
            </Button>
          </div>}
        </div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
                <FormGroup check>
                  <input
                    id='low_bal_alert'
                    type='checkbox'
                    className='form-check-input'
                    style={{borderColor:"black"}}
                    {...register('low_bal_alert')}
                  />
                  <Label check>
                    Enable Low Balance Alert
                  </Label>
                </FormGroup>
            </Col>
            <Col>
              <FormGroup className="d-flex align-items-center">
                  <Label for="threshold" >Alert Threshold: $</Label>
                  <div className='ms-3'>
                    <input
                    type='number'
                    className='form-control border-primary-subtle'
                    id='threshold'
                    name='threshold'
                    placeholder='Enter Threshold'
                    min={0}
                    step={1}
                    disabled={isUpdating}
                    style={{width:"100px"}}
                    {...register("threshold")}
                  />
                  </div>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Button type='submit' color='info'
                  style={{ minWidth: "140px", backgroundColor: "#24ce57", border: "none",fontWeight:"bold" }}
                  disabled={isUpdating}
                >
                  {isUpdating ? <Spinner size='sm'/> : 'Update Alert'}
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </Form>
        
        <Row className="g-3">
          <Col md="4">
            <IconCard
              title="Available Balance"
              text={`$${(Number(cred?.free_credit ?? 0) + Number(cred?.paid_credit ?? 0) + Number(cred?.debt_credit ?? 0)).toLocaleString('en-us')}`}
              icon={FaMoneyCheckDollar}
            />
          </Col>

          <Col md="4">
            <IconCard
              title="Credit Line"
              text={`$${(Number(cred?.debt_owned ?? 0)).toLocaleString('en-us')}`}
              icon={FaMoneyCheckDollar}
            />
          </Col>

          <Col md="4">
            {loggedRole === "00000000-0000-0000-0000-000000000002" && <AddCreditButton text="Add Credits" onClick={handleAddCredits}/>}
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default DisplayCredits
